import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';

import { compose, withState } from 'recompose';
import { reduxForm, formPropTypes, Field, isInvalid, getFormValues, isSubmitting } from 'redux-form';
import { formProps } from '../../../propTypes';

export const FORM_NAME = 'ticketUploadItemForm';

const propTypes = exact({
  setFile: PropTypes.func.isRequired,
  file: PropTypes.instanceOf(File),
  validate: PropTypes.func.isRequired,
  ...formPropTypes,
  ...formProps,
});

export const getTicketUploadSubmissionForm = (state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
    invalid: isInvalid(FORM_NAME)(state),
    submitting: isSubmitting(FORM_NAME)(state),
  };
};


/* NOTE: used for setting the form invalid so able to use action creater to disable button */
const validate = (values) => {
  const errors = {};
  if (!values.hiddenFileInput) {
    errors.hiddenFileInput = 'Required!';
  }
  return errors;
};

const TicketUploadItem = (props) => {
  const {
    setFile, handleSubmit, error, change,
  } = props;

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <input
          type="file"
          onChange={(e) => {
            e.persist();
            const { target: { files: [f] } } = e;
            setFile(f);
            /* Setting to empty string because otherwise it's set to an empty object */
            if (f) {
              change('hiddenFileInput', f);
            } else {
              change('hiddenFileInput', '');
            }
            validate(props);
          }}
        />
        <Field
          name="hiddenFileInput"
          component={() => { return null; }}
        />
        {error
        && <span>{error}</span>}
      </form>
    </div>
  );
};

TicketUploadItem.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = {};

const withRedux = connect(mapStateToProps, mapDispatchToProps);


const withForm = reduxForm({
  form: FORM_NAME,
  validate,
  enableReinitialize: true,
  initialValues: {
    hiddenFileInput: '',
  },
});


const withStateSelector = withState('file', 'setFile', null);

const enhance = compose(
  withStateSelector,
  withRedux,
  withForm,
);


export default enhance(TicketUploadItem);
